

export const FAQ_REQUEST =         "FAQ_REQUEST";
export const FAQ_REQUEST_SUCCESS = "FAQ_SUCCESS";
export const FAQ_REQUEST_FAIL =    "FAQ_FAIL"
